import httpBuildQuery from '../../src/procedures/http-build-query';
import apiPaths from '../api-paths';

export default {
  list() {
    return axios.get(`${ apiPaths.STAFF }/leaves/codes${ httpBuildQuery({ list: true }) }`);
  },
};
